module.exports = __webpack_public_path__ + "static/assets/009f51d3651fce132f62575ef118eefa.svg";